import { inject, Injectable } from '@angular/core';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { resultFrom } from './result';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  http = inject(HttpClient);

  async get(userId: string) {
    return await resultFrom(this.http.get<User>(`${environment.serviceUrl}/users/${userId}`, { withCredentials: true }));
  }

  async put(userId: string, user: User) {
    return await resultFrom(this.http.put(`${environment.serviceUrl}/users/${userId}`, user, { withCredentials: true }));
  }

  async delete(userId: string) {
    return await resultFrom(this.http.delete(`${environment.serviceUrl}/users/${userId}`, { withCredentials: true }));
  }

  async register(user: User) {
    return await resultFrom(
      this.http.post<User>(
        `${environment.serviceUrl}/users/register`,
        {
          name: user.name,
          email: user.email,
          password: user.password,
          administrator: user.administrator
        },
        { withCredentials: true }
      )
    );
  }

  async changePassword(userId: string, password: string) {
    var result = await resultFrom(
      this.http.post(`${environment.serviceUrl}/users/change-password/${userId}`, { password }, { withCredentials: true })
    );
    console.log('changePassword', result);
    return result;
  }
}
